import { IDriverLocation } from "models/dispatch";
import { Tag } from "antd";
import moment from "moment";

interface IProps {
  driver: IDriverLocation;
}

export default function DriverInfo({ driver }: IProps) {
  const isStuck = (driver as any).isStuck;
  const lastUpdated = driver.last_updated ? moment(driver.last_updated).fromNow() : 'Unknown';

  return (
    <div className="w-full">
      {driver.image ? (
        <img
          src={driver.image}
          alt={`${driver.first_name} ${driver.last_name}`}
          width={30}
          height={30}
          className="rounded-full object-cover"
          crossOrigin="anonymous"
          onError={(e) => {
            // Fallback to a default user icon if image fails to load
            const target = e.target as HTMLImageElement;
            target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9IiNkZGQiLz4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxMSIgcj0iNSIgZmlsbD0iIzk5OTk5OSIvPgo8cGF0aCBkPSJNOSAyNUM5IDIyLjUgMTEuNSAyMCAxNSAyMEMxOC41IDIwIDIxIDIyLjUgMjEgMjVWMjdIN1YyNUM5IDI1IFoiIGZpbGw9IiM5OTk5OTkiLz4KPHN2Zz4=';
          }}
        />
      ) : (
        // Placeholder user avatar
        <div
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: '#f0f0f0',
            border: '1px solid #d9d9d9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
          }}
          title="No profile image available"
        >
          👤
        </div>
      )}
      <h1 className="mt-1 text-black font-semibold text-base">
        {driver.first_name} {driver.last_name}
      </h1>
      {isStuck && (
        <div className="mt-1">
          <Tag color="red">⚠️ Stuck Driver</Tag>
        </div>
      )}
      <div className="mt-1 text-xs text-gray-600">
        Last updated: {lastUpdated}
      </div>
      <div className="w-full flex flex-col gap-2 mt-2">
        <div className="flex gap-x-1">
          <p className="text-xs">Model</p>
          <p className="border border-black rounded-3xl text-xs px-2 pb-0.5 pt-0 w-fit">
            {driver.fleet.model}
          </p>
        </div>
        <div className="flex gap-x-1">
          <p className="text-xs">Brand</p>
          <p className="border border-black rounded-3xl text-xs px-2 pb-0.5 pt-0 w-fit">
            {driver.fleet.brand}
          </p>
        </div>
        <div className="flex gap-x-1">
          <p className="text-xs">Plate Num</p>
          <p className="border border-black rounded-3xl text-xs px-2 pb-0.5 pt-0 w-fit">
            {driver.fleet.plate_number}
          </p>
        </div>
        <div className="flex gap-x-1">
          <p className="text-xs">Color</p>
          <p className="border border-black rounded-3xl text-xs px-2 pb-0.5 pt-0 w-fit">
            {driver.fleet.color}
          </p>
        </div>
      </div>
    </div>
  );
}
